import { api } from '../api';
import type { Recording } from '../types';

export function createRecording(input: {
  id: string;
  callId: string;
  contentKeyBase64: string;
  keyVersion: number;
}): Promise<Recording> {
  return api.request('/recordings', { method: 'POST', body: JSON.stringify(input) });
}

export function uploadRecordingChunk(input: {
  recordingId: string;
  channel: 'owner' | 'rami';
  sequence: number;
  ciphertextBase64: string;
  iv: string;
  checksum: string;
  keyVersion: number;
  startMs: number;
  endMs: number;
}): Promise<{ acknowledged: boolean; accepted: boolean }> {
  const { recordingId, channel, sequence, ...body } = input;
  return api.request(
    `/recordings/${encodeURIComponent(recordingId)}/chunks/${channel}/${sequence}`,
    { method: 'PUT', body: JSON.stringify(body) }
  );
}

export function completeRecordingUpload(
  recordingId: string,
  expectedOwnerChunks: number,
  expectedRamiChunks: number
): Promise<Recording> {
  return api.request(`/recordings/${encodeURIComponent(recordingId)}/complete`, {
    method: 'POST',
    body: JSON.stringify({ expectedOwnerChunks, expectedRamiChunks })
  });
}
